import type { ChevronProps } from "react-day-picker";

import { AltArrowLeftIcon, AltArrowRightIcon } from "@/shared/ui/icons";
import { tw } from "@/shared/utils";

export const NavButtons = ({ className, ...props }: ChevronProps) => {
  const Icon =
    props.orientation === "left" ? AltArrowLeftIcon : AltArrowRightIcon;

  return <Icon className={tw("size-6", className)} {...props} />;
};
